export default __webpack_public_path__ + "static/media/nishchal.9e972c57.jpg";